export const team = [
  {
    id: 1,
    name: 'Ricardo Silva',
    role: 'Master Barber',
    specialty: 'Cortes Clássicos',
    bio: 'Mais de 15 anos de experiência. Formado na London School of Barbering, Ricardo é especialista em cortes clássicos e técnicas tradicionais de barbearia.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20barber%20portrait%2C%20mature%20man%20with%20well%20groomed%20beard%2C%20dark%20shirt%2C%20confident%20expression%2C%20barbershop%20background%20with%20warm%20lighting%2C%20cinematic%20portrait%20photography%2C%20masculine%20aesthetic%2C%20professional%20headshot%2C%20charcoal%20and%20amber%20tones&width=600&height=750&seq=team-ricardo-01&orientation=portrait',
  },
  {
    id: 2,
    name: 'Lucas Mendes',
    role: 'Senior Barber',
    specialty: 'Barbas & Navalha',
    bio: 'Especialista em design de barba e técnicas de navalha. Lucas transforma cada barba em uma obra de arte, sempre respeitando o estilo pessoal de cada cliente.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20barber%20portrait%2C%20young%20man%20with%20stylish%20beard%20and%20tattoos%2C%20dark%20casual%20clothing%2C%20confident%20look%2C%20barbershop%20interior%20with%20warm%20lighting%2C%20cinematic%20portrait%2C%20masculine%20vibe%2C%20modern%20professional&width=600&height=750&seq=team-lucas-02&orientation=portrait',
  },
  {
    id: 3,
    name: 'André Costa',
    role: 'Barber & Colorista',
    specialty: 'Pigmentação & Cor',
    bio: 'Referência em micropigmentação capilar no Nordeste. André domina as técnicas mais avançadas de reconstrução capilar e pigmentação natural.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20barber%20portrait%2C%20man%20in%20his%20thirties%20with%20clean%20stylish%20look%2C%20dark%20apron%2C%20focused%20expression%2C%20barbershop%20setting%20with%20warm%20lighting%2C%20cinematic%20portrait%20photography%2C%20masculine%20aesthetic%2C%20professional%20barber&width=600&height=750&seq=team-andre-03&orientation=portrait',
  },
  {
    id: 4,
    name: 'Felipe Nogueira',
    role: 'Barber',
    specialty: 'Cortes Modernos',
    bio: 'Apaixonado por tendências e técnicas contemporâneas. Felipe traz o melhor dos cortes modernos sem perder a essência da barbearia tradicional.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20barber%20portrait%2C%20young%20stylish%20man%20with%20modern%20haircut%2C%20dark%20casual%20style%2C%20friendly%20confident%20expression%2C%20barbershop%20interior%20with%20warm%20ambient%20light%2C%20cinematic%20portrait%2C%20masculine%20aesthetic&width=600&height=750&seq=team-felipe-04&orientation=portrait',
  },
];